import script from "./InvoiceTabTable.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceTabTable.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceTabTable.vue?vue&type=style&index=0&id=49d501a2&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49d501a2"]])

export default __exports__